/**
 * @desc 查询BindingLog
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.IdParameter): Promise<BaseResponse<defs.ResultBean<Array<defs.BindingLog>>>> {
  return fetch({
    url: config.API_HOST + '/base/driver/findBindingLogList',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
